// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PERSON_INDEX_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    PERSON_INDEX_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.personIndexSectionNext
      };
    },
    PERSON_INDEX_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexSectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
